import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import PromoBanner from "./PromoBanner";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Bad response");
      setStatus("success");
      setForm({ name: "", email: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="page">
      <Helmet>
        <title>Contact – Deenzine | Sacs en crochet faits main</title>
        <meta name="description" content="Une question sur un sac, une commande ou une personnalisation ? L'équipe Deenzine vous répond rapidement." />
        <link rel="canonical" href="https://www.deenzine.com/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Deenzine" />
        <meta property="og:url" content="https://www.deenzine.com/contact" />
        <meta property="og:title" content="Contact – Deenzine" />
        <meta property="og:description" content="Contactez Deenzine pour toute question sur vos sacs en crochet faits main." />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Contact – Deenzine" />
        <meta name="twitter:description" content="Contactez Deenzine pour toute question sur vos sacs." />
      </Helmet>

      <PromoBanner />
      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad" style={{ maxWidth: 720, margin: "0 auto" }}>
            <h1 className="h2" style={{ color: "var(--brand)" }}>Nous contacter</h1>
            <p className="p">Réponse sous 24–48h ouvrées.</p>

            <form onSubmit={handleSubmit} style={{ marginTop: 18 }}>
              <label className="p" htmlFor="name" style={{ display: "block", marginBottom: 6 }}>Nom</label>
              <input
                id="name"
                className="input"
                name="name"
                placeholder="Votre nom"
                value={form.name}
                onChange={handleChange}
                required
                autoComplete="name"
              />

              <div style={{ height: 12 }} />

              <label className="p" htmlFor="email" style={{ display: "block", marginBottom: 6 }}>Email</label>
              <input
                id="email"
                className="input"
                type="email"
                name="email"
                placeholder="Votre email"
                value={form.email}
                onChange={handleChange}
                required
                autoComplete="email"
              />

              <div style={{ height: 12 }} />

              <label className="p" htmlFor="message" style={{ display: "block", marginBottom: 6 }}>Message</label>
              <textarea
                id="message"
                className="input"
                name="message"
                placeholder="Votre message"
                value={form.message}
                onChange={handleChange}
                required
                rows={6}
                style={{ resize: "vertical" }}
              />

              <div style={{ height: 14 }} />

              <button className="btn" type="submit" disabled={status === "sending"} style={{ width: "100%" }}>
                {status === "sending" ? "Envoi…" : "Envoyer"}
              </button>

              {status === "success" && (
                <div className="badge" style={{ marginTop: 14 }}>
                  ✅ Message envoyé. Merci !
                </div>
              )}
              {status === "error" && (
                <div className="badge" style={{ marginTop: 14, borderColor: "rgba(179,62,62,.25)" }}>
                  ❌ Erreur d’envoi. Réessaie dans quelques minutes.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
